import produce from 'immer';
import { GROUP_DEVICES_ACTIONS } from '../groupDevices/actions';
import { LOGGERS_MANAGEMENT_ACTIONS } from './actions';
import { RECEIVERS_MANAGEMENT_ACTIONS } from '../receiver/actions';
import TextConstants from 'src/common/helpers/TextConstants';

const initialState = {
  records: [],
  loading: false,
  type: '',
  isLoggerAlarm: false,
  isNextLoggerAlarm: false,
};

export const isFlagAlarm = (flgValue) => {
  return Object.keys(TextConstants.LoggersManagement.LoggerAlarms)
    .map((val) => parseInt(val))
    .includes(flgValue);
};

export const isLoggerAlarmOccurred = (logger) => {
  return (
    (logger._bat !== null &&
      !isNaN(logger._bat) &&
      parseInt(logger._bat) <= 1) ||
    (logger._asi !== null &&
      !isNaN(logger._asi) &&
      parseInt(logger._asi) !== 0) ||
    (logger._mei !== null &&
      !isNaN(logger._mei) &&
      parseInt(logger._mei) !== 0) ||
    (logger._oer !== null &&
      !isNaN(logger._oer) &&
      parseInt(logger._oer) !== 0) ||
    (logger._af1 !== null && !isNaN(logger._af1) && isFlagAlarm(logger._af1)) ||
    (logger._af2 !== null && !isNaN(logger._af2) && isFlagAlarm(logger._af2)) ||
    (logger._af3 !== null && !isNaN(logger._af3) && isFlagAlarm(logger._af3)) ||
    (logger._af4 !== null && !isNaN(logger._af4) && isFlagAlarm(logger._af4)) ||
    (logger._paf !== null && !isNaN(logger._paf) && parseInt(logger._paf) !== 0)
  );
};

const LoggersManagement = (state = initialState, action) => {
  const { type: actionType, payload } = action;
  switch (actionType) {
    case LOGGERS_MANAGEMENT_ACTIONS.GET_LOGGERS:
    case LOGGERS_MANAGEMENT_ACTIONS.ADD_LOGGER:
    case LOGGERS_MANAGEMENT_ACTIONS.UPDATE_LOGGER:
    case LOGGERS_MANAGEMENT_ACTIONS.DELETE_LOGGER:
      return produce(state, (draft) => {
        draft.loading = true;
        draft.type = actionType;
      });
    case LOGGERS_MANAGEMENT_ACTIONS.GET_LOGGERS_SUCCESS:
      const newLoggers = payload.records;
      const alarmSettings = payload.alarmSettings;
      
      newLoggers.forEach((logger) => {
        // fake alarm
        // logger.bat = 3;
        // logger.asi = 0;
        // logger.mei = 0;
        // logger.oer = 0;
        // logger.af1 = 0;
        // logger.af2 = 0;
        // logger.af3 = 0;
        // logger.af4 = 0;
        // logger.paf = 0;

        logger._bat = logger.bat;
        logger._asi = logger.asi;
        logger._mei = logger.mei;
        logger._oer = logger.oer;
        logger._af1 = logger.af1;
        logger._af2 = logger.af2;
        logger._af3 = logger.af3;
        logger._af4 = logger.af4;
        logger._paf = logger.paf;
      });

      let _isNextLoggerAlarm = false;

      const loggersAlarmFlagSnoozed =
        alarmSettings.deviceAlarmSettings?.alarmFlagsSnoozed?.loggers;
      if (loggersAlarmFlagSnoozed) {
        newLoggers.forEach((logger) => {
          const _deviceId = logger.deviceId;
          const abnormal_flags = logger['afl'] || {};
          const deviceIdSoonedFlags = loggersAlarmFlagSnoozed[_deviceId];
          if (deviceIdSoonedFlags) {
            if (deviceIdSoonedFlags['_bat'] && !abnormal_flags.bat || parseInt(abnormal_flags.bat) === deviceIdSoonedFlags['_bat']) {
              logger._bat = undefined;
            }
            if (deviceIdSoonedFlags['_asi'] && !abnormal_flags.asi || parseInt(abnormal_flags.asi) === deviceIdSoonedFlags['_asi']) {
              logger._asi = undefined;
            }
            if (deviceIdSoonedFlags['_mei'] && !abnormal_flags.mei || parseInt(abnormal_flags.mei) === deviceIdSoonedFlags['_mei']) {
              logger._mei = undefined;
            }
            if (deviceIdSoonedFlags['_oer'] && !abnormal_flags.oer || parseInt(abnormal_flags.oer) === deviceIdSoonedFlags['_oer']) {
              logger._oer = undefined;
            }
            if (deviceIdSoonedFlags['_af1'] && !abnormal_flags.af1 || parseInt(abnormal_flags.af1) === deviceIdSoonedFlags['_af1']) {
              logger._af1 = undefined;
            }
            if (deviceIdSoonedFlags['_af2'] && !abnormal_flags.af2 || parseInt(abnormal_flags.af2) === deviceIdSoonedFlags['_af2']) {
              logger._af2 = undefined;
            }
            if (deviceIdSoonedFlags['_af3'] && !abnormal_flags.af3 || parseInt(abnormal_flags.af3) === deviceIdSoonedFlags['_af3']) {
              logger._af3 = undefined;
            }
            if (deviceIdSoonedFlags['_af4'] && !abnormal_flags.af4 || parseInt(abnormal_flags.af4) === deviceIdSoonedFlags['_af4']) {
              logger._af4 = undefined;
            }
            if (deviceIdSoonedFlags['_paf'] && !abnormal_flags.paf || parseInt(abnormal_flags.paf) === deviceIdSoonedFlags['_paf']) {
              logger._paf = undefined;
            }
          }
        });
      }

      let isLoggerAlarm = false;
      newLoggers.forEach((logger) => {
        const isAlarm = isLoggerAlarmOccurred(logger);
        logger.isAlarm = isAlarm;
        isLoggerAlarm = isLoggerAlarm || isAlarm;
      });

      if (!alarmSettings.isSnoozeExpired && isLoggerAlarm) {
        _isNextLoggerAlarm = true;
      }

      return produce(state, (draft) => {
        draft.isNextLoggerAlarm = _isNextLoggerAlarm;
        draft.records = newLoggers;
        draft.loading = false;
        draft.isLoggerAlarm = isLoggerAlarm;
        draft.type = actionType;
      });
    case LOGGERS_MANAGEMENT_ACTIONS.ADD_LOGGER_SUCCESS:
      return produce(state, (draft) => {
        draft.records = [payload, ...state.records];
        draft.loading = false;
        draft.type = actionType;
      });
    case LOGGERS_MANAGEMENT_ACTIONS.UPDATE_LOGGER_SUCCESS:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.type = actionType;
      });
    case LOGGERS_MANAGEMENT_ACTIONS.DELETE_LOGGER_SUCCESS:
      return produce(state, (draft) => {
        draft.records = state.records.filter((x) => x.deviceId !== payload);
        draft.loading = false;
        draft.type = actionType;
      });

    case LOGGERS_MANAGEMENT_ACTIONS.GET_LOGGERS_ERROR:
    case LOGGERS_MANAGEMENT_ACTIONS.ADD_LOGGER_ERROR:
    case LOGGERS_MANAGEMENT_ACTIONS.UPDATE_LOGGER_ERROR:
    case LOGGERS_MANAGEMENT_ACTIONS.DELETE_LOGGER_ERROR:
    case LOGGERS_MANAGEMENT_ACTIONS.UPDATE_LOGGER_CLEAN_STATE:
    case LOGGERS_MANAGEMENT_ACTIONS.ADD_LOGGER_CLEAN_STATE:
    case LOGGERS_MANAGEMENT_ACTIONS.DELETE_LOGGER_CLEAN_STATE:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.type = actionType;
      });

    case GROUP_DEVICES_ACTIONS.ADD_GROUP_DEVICES_SUCCESS:
    case GROUP_DEVICES_ACTIONS.UNLINK_GROUP_DEVICE_SUCCESS:
      return produce(state, (draft) => {
        draft.type = actionType;
        draft.records = payload.loggers || state.records || [];
      });
    case LOGGERS_MANAGEMENT_ACTIONS.RESET_LOGGER_NEXT_ALARM:
      return produce(state, (draft) => {
        draft.type = actionType;
        draft.isNextLoggerAlarm = false;
      });

    default:
      return state;
  }
};

export default LoggersManagement;
